export default __webpack_public_path__ + "static/media/long-arrow-up-icon.02b45a7f.svg";